import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { ExpiryReason } from "@/models/ExpiryReason";
import { EXPIRY_UNIT_TYPE } from "@/constants/expiry-reason-constant";
import { WizardSummaryLayout } from '@/components/wizard/wizard-summary-layout';

interface SummaryStepProps {
    onBack: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<ExpiryReason>();

    const getUnitLabel = (unit: number) => {
        if (unit === EXPIRY_UNIT_TYPE.WEEKS) {
            return translate.byKey(TranslationKeys.weeks);
        }
        else if (unit === EXPIRY_UNIT_TYPE.MONTHS) {
            return translate.byKey(TranslationKeys.months);
        }

        return translate.byKey(TranslationKeys.days);
    };

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <span className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.details)}:</span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.name)}: <span className="text-sm text-black">{values.name}</span></span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.duration)}: <span className="text-sm text-black">{values.durationValue}</span></span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.units)}: <span className="text-sm text-black">{getUnitLabel(Number(values.durationUnit))}</span></span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.durationWarning)}: <span className="text-sm text-black">{ values.durationWarnValue }</span></span>
            </div>
        </div>
    </WizardSummaryLayout>;
};

export default SummaryStep;